import { refresh } from "./apis/refresh";
import { setTokens } from "./setTokens";
import { emit, triggerError } from "../utils/eventManager";
import { getCookieDomain } from "../utils/config";
import { removeCookies } from "../utils/cookieManager";
import { getBroadcastChannel } from "../utils/broadcastChannel";
import { sendNewRelicEvent } from "../utils/newRelicEvents";
export { refreshToken, resolveOngoingRefresh, initOngoingRefresh };
var $ongoingRefresh;
/* istanbul ignore next */
var $resolve = function $resolve() {};
async function refreshToken() {
  /* istanbul ignore next */
  if (typeof window === 'undefined') return;
  try {
    if ($ongoingRefresh) {
      return $ongoingRefresh;
    }
    sendNewRelicEvent({
      EventName: 'refresh_start'
    });
    getBroadcastChannel().postMessage({
      action: 'refreshStart'
    });
    $ongoingRefresh = refresh();
    var tokens = await $ongoingRefresh;
    var idToken = tokens.idToken,
      accessToken = tokens.accessToken;
    $ongoingRefresh = null;
    getBroadcastChannel().postMessage({
      action: 'refreshEnd',
      payload: {
        tokens: tokens
      }
    });
    sendNewRelicEvent({
      EventName: 'refresh_success'
    });
    await setTokens({
      idToken: idToken,
      accessToken: accessToken,
      callInitSession: false,
      broadcast: true,
      authActionType: 'refresh_token'
    });
    return tokens;
  } catch (err) {
    $ongoingRefresh = null;
    if (err.code == 'invalid_grant') {
      sendNewRelicEvent({
        EventName: 'refresh_fail',
        reason: 'invalid grant'
      });
      removeCookies(getCookieDomain());
      emit('logout.success');
    } else {
      sendNewRelicEvent({
        EventName: 'refresh_fail',
        reason: err
      });
      triggerError('refresh', err);
    }
    getBroadcastChannel().postMessage({
      action: 'refreshEnd'
    });
  }
}
function initOngoingRefresh() {
  $ongoingRefresh = new Promise(function (resolve) {
    $resolve = resolve;
  });
}
function resolveOngoingRefresh(tokens) {
  $ongoingRefresh = null;
  $resolve(tokens);
  $resolve = function $resolve() {};
}